import { IconDownload } from '@tabler/icons-react';
import { NSButton, NSCard } from 'bricks';
import useAuthContext from 'contexts/AuthContext';
import { formatDateLong, formatFileSize } from 'ns_libs/formatter';
import useDownloadExtractedProForma from 'queries/ExtractedProForma/useDownloadExtractedProForma';
import { IExtractedProFormaSummary } from 'types/db/ExtractedProForma';
import {
    DOWNLOAD_ORIGINAL_WORKBOOK, EXTRACTION_DATE_LABEL, FILE_NAME_LABEL, FILE_SIZE_LABEL, SOURCE_WORKBOOK_TITLE,
} from '../../constants';
import './SourceWorkbook.scss';

export interface ISourceWorkbookProps {
    extractedProForma: IExtractedProFormaSummary;
}

/**
 * Shows the workbook an extraction came from and offers it for download under its original file name.
 */
const SourceWorkbook = ({ extractedProForma }: ISourceWorkbookProps) => {
    const { selectedOrganizationId } = useAuthContext();
    const { mutate: downloadWorkbook, isPending } = useDownloadExtractedProForma();

    const extractedAt = extractedProForma.extractionCompletedAt ?? extractedProForma.createdAt;

    const handleDownload = () => downloadWorkbook({
        organizationId: selectedOrganizationId!,
        dealId: extractedProForma.dealId,
        extractedProFormaId: extractedProForma.id,
    });

    return (
        <div className="SourceWorkbook px-3 pt-3">
            <div className="font-12 text-muted text-uppercase">{SOURCE_WORKBOOK_TITLE}</div>
            <NSCard className="SourceWorkbook__card NSCard--level-2 mt-2 p-2">
                <div className="font-11 text-muted text-uppercase">{FILE_NAME_LABEL}</div>
                <div className="text-dark font-weight-bold text-break">{extractedProForma.fileName}</div>
                <div className="font-11 text-muted text-uppercase mt-2">{FILE_SIZE_LABEL}</div>
                <div className="text-dark font-weight-bold">{formatFileSize(extractedProForma.fileSize)}</div>
                <div className="font-11 text-muted text-uppercase mt-2">{EXTRACTION_DATE_LABEL}</div>
                <div className="text-dark font-weight-bold">{`Extracted ${formatDateLong(extractedAt)}`}</div>
                <NSButton
                    callback={handleDownload}
                    color="primary"
                    className="font-13 mt-3"
                    size="sm"
                    outline
                    icon={IconDownload}
                    text={DOWNLOAD_ORIGINAL_WORKBOOK}
                    isLoading={isPending}
                    allowReadOnlyAccess
                />
            </NSCard>
        </div>
    );
};

export default SourceWorkbook;
